<sbnb-apps-detail-page
  vendorCode="clearing"
  name="Clearing"
  logoTile="/assets/images/apps/clearing.svg"
  builtBy="Clearing"
  builtByLink="https://getclearing.co/"
  [categories]="['Accounting']"
  [permissions]="[
    AppPermission.propertyListingRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead,
    AppPermission.calendarRead
  ]"
  email="support@getclearing.co"
  [helpArticles]="[
    {
      id: '8149696',
      title: 'How to integrate Clearing with Hospitable to automate your bookkeeping'
    }
  ]">
  <ng-container description>
    <div class="space-y-4">
      <p>
        Clearing is a complete trust accounting and bookkeeping automation solution tailored for Short-Term Rental
        property managers to close their books faster than ever before.
      </p>

      <p>
        Property managers use Clearing to track their revenues from multiple sources, manage their expenses, generate
        financial statements & trust allocation reporting, reconcile booking financials & bank accounts, and pay
        homeowners & vendors.
      </p>

      <p>
        In the spirit of trust accounting, funds collected can be tracked in separate balances by homeowners and owners
        can have a dedicated portal to track their properties' transactions and funds in real time. Accountants can be
        invited with restricted permissions to review and manage the books.
      </p>

      <div class="py-6">
        <iframe
          class="w-full aspect-video rounded-lg"
          src="https://www.youtube.com/embed/qwXbhT3QEB4"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          data-element="clearing-demo-video"></iframe>
      </div>
      <sbnb-image-carousel
        class="pt-6"
        [images]="[
          '/assets/images/apps/clearing/1.png',
          '/assets/images/apps/clearing/2.png',
          '/assets/images/apps/clearing/3.png',
          '/assets/images/apps/clearing/4.png'
        ]"></sbnb-image-carousel>
    </div>
  </ng-container>
</sbnb-apps-detail-page>
